import React, { useState, useEffect } from "react";
import { useNavigate, useParams, NavLink, Outlet } from "react-router-dom";
import { FaHistory, FaTrash } from "react-icons/fa";
import { Spinner, Modal, Button } from "react-bootstrap";
import { connect } from "react-redux";
import { Icon } from "../../components";
import {
  ChangeBusStatusApi,
  getBusApi,
  removeDeviceid,
  updateBusApi,
} from "../../services/TransportService";
import { toast } from "react-toastify";
import { FiRefreshCcw } from "react-icons/fi";
import { Tooltip } from "@mui/material";
import { formatTimeAgo } from "../../utilities";
import { getBusStatusBadge } from "../../utilities";
import { getlivestatus } from "../../services/TransportService";
import { FaExclamationTriangle } from "react-icons/fa";
import { FaFileAlt } from "react-icons/fa";
import { CgDetailsMore } from "react-icons/cg";
import { GoArrowSwitch } from "react-icons/go";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import ReplaceBusModal from "../Route/Trip/ReplaceBusModal";
function BusDetailsPage({ userRole }) {
  const { id } = useParams();
  const [removeDeviceConfirm, setDeviceRemoveConfirm] = useState("");
  const [errormessage, setErrormessage] = useState("");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [refreshloading, setRefreshLoading] = useState(false);
  const [removeDeviceloading, setRemoveDeviceLoading] = useState(false);
  const [deviceRemoveDialog, setDeviceRemoveDialog] = useState(false);
  const [replaceBusModal, setreplaceBusModal] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [ActiveStatusDialog, setActiveStatusDialog] = useState(false);
  const [InactiveStatusDialog, setInActiveStatusDialog] = useState(false);
  const [ActiveStatusLoading, setActiveStatusLoading] = useState(false);
  const [InActiveStatusLoading, setInActiveStatusLoading] = useState(false);
  const handledeviceremovedialog = () => {
    setDeviceRemoveDialog(!deviceRemoveDialog);
  };
  const handleClick = () => {
    if (refreshloading) return; // Prevent repeated clicks
    setRefreshLoading(true);
    getlivestatus(id)
      .then((res) => {
        setData({ ...data, ...res?.data?.data });
        toast.success("Retrive Successfully");
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || err?.response?.data?.error);
      })
      .finally(() => {
        setRefreshLoading(false);
      });
  };
  const [addFormFields, setAddFormFields] = useState({
    number_plate: "",
    capacity: 40,
    model: "",
    monthly_travel_distance: "",
  });
  const [errordata, setErrordata] = useState({
    number_plate: "",
    capacity: "",
    model: "",
    monthly_travel_distance: "",
  });
  const [modalVisible, setModalVisible] = useState(false);
  const [isAddSubmiting, setIsAddSubmiting] = useState(false);
  const navigate = useNavigate();
  const fetchBus = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getBusApi(id);
      setData(response?.data);
    } catch (err) {
      setError(err.message || "An error occurred while fetching data data.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchBus();
  }, [id, refresh]);

  const handleToggleModal = () => {
    if (modalVisible) {
      setErrormessage("");
      setAddFormFields({
        number_plate: "",
        capacity: 40,
        is_active: false,
        model: "",
        monthly_travel_distance: "",
      });
      setErrordata({
        number_plate: "",
        capacity: "",
        model: "",
        monthly_travel_distance: "",
      });
    } else {
      setAddFormFields({
        number_plate: data?.bus?.number_plate || "",
        capacity: data?.bus?.capacity || "",
        model: data?.bus?.model || "",
        monthly_travel_distance: data?.bus?.monthly_travel_distance || "",
      });
    }
    setModalVisible((prev) => !prev);
  };

  const handleSubmit = () => {
    setIsAddSubmiting(true);
    updateBusApi(id, addFormFields)
      .then((resp) => {
        fetchBus();
        handleToggleModal();
        toast.success("Update Successfully");
      })
      .catch((error) => {
        setErrormessage(
          error?.response?.data?.message ||
            error?.response?.data?.error ||
            "Please try after sometime"
        );
      })
      .finally(() => {
        setIsAddSubmiting(false);
      });
  };
  const handleadd = () => {
    let valid = true;
    const error = { number_plate: "", capacity: "" };
    if (!addFormFields.number_plate) {
      error.number_plate = "Mandatory Field";
      valid = false;
    }
    if (!addFormFields.capacity) {
      error.capacity = "Mandatory Field";
      valid = false;
    }
    if (!addFormFields.model) {
      error.model = "Manadatory Field";
      valid = false;
    }
    if (!addFormFields.monthly_travel_distance) {
      error.monthly_travel_distance = "Mandatory Field";
      valid = false;
    }
    setErrordata(error);
    if (valid) {
      handleSubmit();
    }
  };
  const tabs = [
    {
      name: "Trips",
      icons: <FaFileAlt className="me-1" />,
      path: `/bus/${id}`,
    },
    {
      name: "Replacement Log",
      icons: <GoArrowSwitch className="me-1" />,
      path: `/bus/${id}/replacement-log`,
    },
    {
      name: "Trip Logs",
      icons: <FaHistory className="me-1" />,
      path: `/bus/${id}/trip-log`,
    },
    {
      name: "Active Passes",
      icons: <CgDetailsMore className="me-1" />,
      path: `/bus/${id}/active-employee`,
    },
  ];
  const handleremovedevice = () => {
    setRemoveDeviceLoading(true);
    removeDeviceid(id)
      .then((res) => {
        handledeviceremovedialog();
        toast.success("Device remove successfully");
        fetchBus();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setRemoveDeviceLoading(false);
      });
  };
  const handleBusActive = () => {
    setActiveStatusLoading(true);
    ChangeBusStatusApi(id, { status: "Active" })
      .then((res) => {
        setActiveStatusDialog(false);
        toast.success("Status Update Successfully");
        fetchBus();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Please try again later"
        );
      })
      .finally(() => {
        setActiveStatusLoading(false);
      });
  };
  const handleBusInActive = () => {
    setInActiveStatusLoading(true);
    ChangeBusStatusApi(id, { status: "Inactive" })
      .then((res) => {
        setInActiveStatusDialog(false);
        toast.success("Status Update Successfully");
        fetchBus();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Please try again later"
        );
      })
      .finally(() => {
        setInActiveStatusLoading(false);
      });
  };
  if (loading)
    return (
      <div className="text-center my-4">
        <Spinner animation="border" variant="primary" />
      </div>
    );

  return (
    <div>
      {error ? (
        <div className="alert alert-danger">{error}</div>
      ) : (
        <div className="card">
          <div className="row px-2">
            <div className="col-12 col-md-4 border-end p-4">
              <div className="d-flex align-items-center justify-content-between pb-2">
                <div className="d-flex align-items-center">
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm btn-circle"
                    onClick={() => navigate("/buses")}
                  >
                    <Icon name="arrow-left"></Icon>
                  </button>
                  <h4 className="bio-block-title mx-3">Bus Details</h4>
                </div>
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={handleToggleModal}
                >
                  <Icon name="edit" />
                  <span>Edit</span>
                </Button>
              </div>
              <div className="mb-1">
                <ul className="list-group">
                  <li className="list-group-item border-0 px-0 py-1 bg-transparent d-flex gap-1 small">
                    <span className="title flex-shrink-0 w-50 fw-medium">
                      Number:
                    </span>
                    <span className="text-break text">
                      {data?.bus?.number_plate}
                    </span>
                  </li>
                  <li className="list-group-item border-0 px-0 py-1 d-flex gap-1 small">
                    <span
                      className="title fw-medium flex-shrink-0 w-50"
                      style={{ fontWeight: "500" }}
                    >
                      Model:
                    </span>
                    <span className="text-break text">{data?.bus?.model}</span>
                  </li>
                  <li className="list-group-item border-0 px-0 py-1 bg-transparent d-flex gap-1 small">
                    <span
                      className="title fw-medium flex-shrink-0 w-50"
                      style={{ fontWeight: "500" }}
                    >
                      Capacity:
                    </span>
                    <span className="text-break text">
                      {data?.bus?.capacity}
                    </span>
                  </li>
                  <li className="list-group-item border-0 px-0 py-1 bg-transparent d-flex gap-1 small">
                    <span
                      className="title fw-medium flex-shrink-0 w-50"
                      style={{ fontWeight: "500" }}
                    >
                      Monthly Travel:
                    </span>
                    <span className="text-break text">
                      {`${data?.bus?.monthly_travel_distance} km`}
                    </span>
                  </li>
                  <li className="list-group-item border-0 px-0 py-1 d-flex gap-1">
                    <span
                      className="small title fw-medium flex-shrink-0 w-50"
                      style={{ fontWeight: "500" }}
                    >
                      Status:
                    </span>
                    <span className={getBusStatusBadge(data?.bus?.status)}>
                      {data?.bus?.status}
                    </span>
                  </li>
                  <li className="list-group-item border-0 px-0 py-1 d-flex flex-column gap-1">
                    <span
                      className="title fw-medium small"
                      style={{ fontWeight: "500" }}
                    >
                      Update Status:
                    </span>
                    <div className="d-flex flex-wrap gap-1">
                      {data?.bus?.status?.toLowerCase() == "active" ? (
                        <>
                          <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => setreplaceBusModal(true)}
                          >
                            <Icon name="edit" />
                            <span className="ms-1">Replace</span>
                          </button>
                        </>
                      ) : ["inactive", "maintenance"].includes(
                          data?.bus?.status?.toLowerCase()
                        ) ? (
                        <>
                          <button
                            className="btn btn-sm btn-outline-info"
                            onClick={() => setActiveStatusDialog(true)}
                          >
                            <Icon name="edit" />
                            <span className="ms-1">Active</span>
                          </button>
                        </>
                      ) : data?.bus?.status?.toLowerCase() == "breakdown" ? (
                        <>
                          <button
                            className="btn btn-sm btn-outline-info"
                            onClick={() => setActiveStatusDialog(true)}
                          >
                            <Icon name="edit" />
                            <span className="ms-1">Active</span>
                          </button>
                          <button
                            className="btn btn-sm btn-outline-warning"
                            onClick={() => setInActiveStatusDialog(true)}
                          >
                            <Icon name="edit" />
                            <span className="ms-1">In Active</span>
                          </button>
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                  </li>
                </ul>
              </div>
              <div className="mt-3 mb-2">
                <div className="card">
                  <div className="border-bottom p-1 mb-2 d-flex justify-content-between align-items-center">
                    <span className="text-primary fw-semibold">
                      Device Info
                    </span>
                    <div className="d-flex gap-1">
                      <Tooltip title="Refresh" arrow>
                        <span
                          className="me-1 cursor-pointer d-inline-flex align-items-center justify-content-center bg-light"
                          onClick={handleClick}
                          style={{
                            padding: "5px",
                            backgroundColor: "rgb(226, 225, 225)",
                            borderRadius: "5px",
                          }}
                          // style={{ width: "24px", height: "24px" }}
                        >
                          {refreshloading ? (
                            <Spinner
                              animation="border"
                              variant="primary"
                              size="sm"
                            />
                          ) : (
                            <FiRefreshCcw style={{ fontSize: "18px" }} />
                          )}
                        </span>
                      </Tooltip>
                      {data?.bus.is_device_linked && (
                        <>
                          <Tooltip title="Remove device" arrow>
                            <span
                              className="me-1 cursor-pointer d-inline-flex align-items-center justify-content-center bg-light"
                              onClick={handledeviceremovedialog}
                              style={{
                                padding: "5px 6px",
                                backgroundColor: "rgb(226, 225, 225)",
                                borderRadius: "5px",
                              }}
                              // style={{ width: "24px", height: "24px" }}
                            >
                              <FaTrash
                                style={{
                                  fontSize: "15px",
                                  color: "rgb(255, 56, 56)",
                                }}
                              />
                            </span>
                          </Tooltip>
                        </>
                      )}
                    </div>
                  </div>
                  <div className="px-2 mb-1">
                    <p>
                      <span
                        className="text-secondary"
                        style={{ fontWeight: "500" }}
                      >
                        Status:
                      </span>{" "}
                      <span
                        className={`badge text-bg-${
                          data?.bus?.is_device_online
                            ? "success-soft"
                            : "danger-soft"
                        }`}
                      >
                        {data?.bus?.is_device_online ? "Online" : "Offline"}
                      </span>
                    </p>
                    <p>
                      <span
                        className="text-secondary"
                        style={{ fontWeight: "500" }}
                      >
                        Last Updated:
                      </span>{" "}
                      {formatTimeAgo(data?.bus?.updated_at)}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-8 p-0">
              <div className="border-bottom p-2 mb-2">
                <ul className="custom-nav1 nav nav-pills">
                  {tabs.map((tab) => (
                    <li className="nav-item" key={tab.path}>
                      <NavLink
                        to={tab.path}
                        end={tab.path === `/bus/${id}`}
                        className={({ isActive }) =>
                          "nav-link rounded-pill" + (isActive ? " active" : "")
                        }
                      >
                        {tab.icons}
                        {tab.name}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="tab-content p-0">
                <Outlet />
              </div>
            </div>
          </div>
        </div>
      )}
      <Modal
        show={modalVisible}
        onHide={handleToggleModal}
        centered
        className="custom-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Bus</Modal.Title>
        </Modal.Header>

        <Modal.Body className="py-4">
          <div className="filter-sections">
            {errormessage && (
              <div className="alert alert-danger">{errormessage}</div>
            )}
            <div className="mb-3">
              <label htmlFor="number_plate" className="form-label">
                Registration Number
              </label>
              <input
                type="text"
                className={`form-control ${
                  errordata.number_plate ? "is-invalid" : ""
                }`}
                id="number_plate"
                placeholder="Enter Registration Number"
                value={addFormFields.number_plate}
                onChange={(e) =>
                  setAddFormFields({
                    ...addFormFields,
                    number_plate: e.target.value.toUpperCase(),
                  })
                }
              />
            </div>
            <div className="mb-3">
              <label htmlFor="capacity" className="form-label">
                Capacity
              </label>
              <input
                type="number"
                className={`form-control ${
                  errordata.capacity ? "is-invalid" : ""
                }`}
                id="capacity"
                placeholder="Enter Capacity"
                value={addFormFields.capacity}
                onChange={(e) =>
                  setAddFormFields({
                    ...addFormFields,
                    capacity: e.target.value,
                  })
                }
              />
            </div>
            <div className="row mb-2 px-1">
              <div className="col-6">
                <label className="form-label">Monthly Distance</label>
                <input
                  type="text"
                  className={`form-control ${
                    errordata.monthly_travel_distance ? "is-invalid" : ""
                  }`}
                  placeholder="Travel distance"
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) {
                      setAddFormFields({
                        ...addFormFields,
                        monthly_travel_distance: value,
                      });
                    }
                  }}
                  value={addFormFields.monthly_travel_distance}
                />
                {/* <Select
                  className="react-select"
                  classNamePrefix="select"
                  options={deviceidoption}
                  onChange={(data) => {
                    setAddFormFields({
                      ...addFormFields,
                      device_id: data?.value || "",
                    });
                  }}
                  value={deviceidoption.filter(
                    (data) => data.value === addFormFields.device_id
                  )}
                /> */}
              </div>
              <div className="col-6">
                <label className="form-label">Model</label>
                <input
                  type="text"
                  className={`form-control ${
                    errordata.model ? "is-invalid" : ""
                  }`}
                  placeholder="Model"
                  onChange={(e) =>
                    setAddFormFields({
                      ...addFormFields,
                      model: e.target.value,
                    })
                  }
                  value={addFormFields.model}
                />
                {/* <Select
                  className="react-select"
                  classNamePrefix="select"
                  options={modeloption}
                  onChange={(data) => {
                    setAddFormFields({
                      ...addFormFields,
                      model: data?.value || "",
                    });
                  }}
                  value={modeloption.filter(
                    (data) => data.value === addFormFields.model
                  )}
                />
                {errordata.model && (
                  <small className="text-danger">{errordata.model}</small>
                )} */}
              </div>
            </div>
            {/* <div>
              <div
                className="form-check form-check-sm"
                style={{ fontSize: "0.8rem" }}
              >
                <input
                  className="form-check-input"
                  type="checkbox"
                  name={"is_active"}
                  id={"is-active"}
                  checked={addFormFields.is_active}
                  onChange={(e) =>
                    setAddFormFields({
                      ...addFormFields,
                      is_active: e.target.checked,
                    })
                  }
                />
                <label className="form-check-label" htmlFor={"is-active"}>
                  Set Active
                </label>
              </div>
            </div> */}
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="outline-secondary"
            disabled={isAddSubmiting}
            onClick={handleToggleModal}
          >
            Cancel
          </Button>

          <Button
            variant="primary"
            disabled={isAddSubmiting}
            onClick={handleadd}
          >
            Update{" "}
            {isAddSubmiting && (
              <span
                className="spinner-border spinner-border-sm ms-2"
                role="status"
                aria-hidden="true"
              ></span>
            )}
          </Button>
        </Modal.Footer>
      </Modal>
      <SecurityDialog
        open={deviceRemoveDialog}
        onClose={handledeviceremovedialog}
        onConfirm={handleremovedevice}
        loading={removeDeviceloading}
      />
      <ReplaceBusModal
        refresh={refresh}
        setRefresh={setRefresh}
        busid={id}
        modalopen={replaceBusModal}
        setModalopen={setreplaceBusModal}
      />
      <Dialog
        open={ActiveStatusDialog}
        onClose={() => setActiveStatusDialog(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle className="d-flex align-items-center gap-2 text-primary">
          <FaExclamationTriangle className="text-warning" />
          Confirm Device Active
        </DialogTitle>

        <DialogContent>
          <DialogContentText className="text-dark">
            <div className="alert alert-info mb-3 p-2">
              <strong>Warning:</strong> This action is <u>permanent</u> and
              cannot be undo.
            </div>
            To continue, please click <code>ACTIVE</code> button below:
          </DialogContentText>
        </DialogContent>

        <DialogActions className="px-3 pb-3">
          <button
            className="btn btn-outline-dark"
            onClick={() => setActiveStatusDialog(false)}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary"
            disabled={ActiveStatusLoading}
            onClick={handleBusActive}
          >
            {ActiveStatusLoading && (
              <Spinner animation="border" size="sm" className="me-1" />
            )}
            Confirm
          </button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={InactiveStatusDialog}
        onClose={() => setInActiveStatusDialog(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle className="d-flex align-items-center gap-2 text-primary">
          <FaExclamationTriangle className="text-warning" />
          Confirm Device In Active
        </DialogTitle>

        <DialogContent>
          <DialogContentText className="text-dark">
            <div className="alert alert-info mb-3 p-2">
              <strong>Warning:</strong> This action is <u>permanent</u> and
              cannot be undo.
            </div>
            To continue, please click <code>IN ACTIVE</code> button below:
          </DialogContentText>
        </DialogContent>

        <DialogActions className="px-3 pb-3">
          <button
            className="btn btn-outline-dark"
            onClick={() => setInActiveStatusDialog(false)}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary"
            disabled={InActiveStatusLoading}
            onClick={handleBusInActive}
          >
            {InActiveStatusLoading && (
              <Spinner animation="border" size="sm" className="me-1" />
            )}
            In Active
          </button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

const mapStateToProps = (state) => ({
  userRole: state.auth.data?.role || "data",
});
const SecurityDialog = ({ open, onClose, onConfirm, loading }) => {
  const [input, setInput] = useState("");
  useEffect(() => {
    console.log(loading);
    if (!open) {
      setInput("");
    }
  }, [open]);
  const isConfirmed = input.trim().toUpperCase() === "REMOVE";
  const handlclick = () => {
    if (isConfirmed) {
      setInput("");
      onConfirm();
      onClose();
    }
  };
  const handlechange = (e) => {
    setInput(e.target.value);
  };
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle className="d-flex align-items-center gap-2 text-danger">
        <FaExclamationTriangle className="text-warning" />
        Confirm Device Removal
      </DialogTitle>

      <DialogContent>
        <DialogContentText className="text-dark">
          <div className="alert alert-warning mb-3 p-2">
            <strong>Warning:</strong> This action is <u>permanent</u> and cannot
            be undo.
          </div>
          To continue, please type <code>REMOVE</code> below:
        </DialogContentText>

        <input
          type="text"
          className={`form-control mt-2 ${
            input ? (isConfirmed ? "is-valid" : "is-invalid") : ""
          }`}
          placeholder="Type REMOVE to confirm"
          value={input}
          onChange={handlechange}
        />
      </DialogContent>

      <DialogActions className="px-3 pb-3">
        <button className="btn btn-outline-danger" onClick={onClose}>
          Cancel
        </button>
        <button
          className="btn btn-primary"
          disabled={loading}
          onClick={handlclick}
        >
          {Boolean(loading) && <Spinner animation="border" size="sm" />}
          Confirm
        </button>
      </DialogActions>
    </Dialog>
  );
};
export default connect(mapStateToProps)(BusDetailsPage);
